
// 批量下载图片
import JSZip from "jszip";
import FileSaver from "file-saver";

Vue.prototype.bolkDown = async function (arr, zipName) {
  console.log('下载信息', arr, zipName)
  // console.log(window.loadingPage)
  try {
    let zip = new JSZip();
    for (let i = 0; i < arr.length; i++) {
      let lst = arr[i].url.split(".");
      let fileType = lst[lst.length - 1];
      if (fileType.toLocaleUpperCase() === "PDF") {
        await getFile(arr[i].url).then((pdf) => {
          zip.file("HelloPDF.pdf", pdf, { binary: true });
        });
      } else {
        await getBase64Image(arr[i].url).then((res) => {
          zip.file(arr[i].name + "." + fileType, res, { base64: true });
        });
      }
    }
    downImg(zip, zipName);
  } catch (err) {
  }
}

function downImg(zip, zipName) {
  zip
    .generateAsync({
      type: "blob",
    })
    .then((content) => {
      let fileName = zipName + ".zip";
      FileSaver.saveAs(content, fileName);
      window.loadingPage.close();

    });
}
//****传入图片链接，返回base64数据
function getBase64Image(url) {
  return new Promise((resolve, reject) => {
    var base64 = "";
    var img = new Image();
    img.setAttribute("crossOrigin", "Anonymous");
    img.onload = () => {
      base64 = image2Base64(img);
      resolve(base64.split(",")[1]);
    };
    img.onerror = () => reject("加载失败"); // 这里可能会有跨域失败的问题，解决方案同上，url + 随机数
    img.src = url;
  });
}
function image2Base64(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL;
}
//****传入文件链接，返回arraybuffer数据
function getFile(url) {
  return new Promise((resolve, reject) => {
    // 这里的$http是Vue里的axios
    this.$http({
      method: "get",
      url,
      responseType: "arraybuffer",
    })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject("PDF加载失败：" + error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/bolkDown.js